import { z } from 'zod';

export const AGENT_UPDATE_REQUIRED = 'AGENT_UPDATE_REQUIRED';
export const AGENT_UPDATE_MESSAGE = 'agent の更新が必要です（設定 → agent の一覧）';
const CommandEnvelopeSchema = z.object({
  type: z.string().min(1),
  id: z.string().min(1).max(200),
  serverId: z.string().min(1).optional(),
});
/** A new command type with a valid envelope can receive an error without losing the connection. */
export function unsupportedCommand(raw: unknown, known: (type: string) => boolean, serverId?: string) {
  const envelope = CommandEnvelopeSchema.safeParse(raw);
  if (!envelope.success || (serverId !== undefined && envelope.data.serverId !== serverId)) return null;
  return known(envelope.data.type) ? null : envelope.data;
}
